import { Cascader, Col, Row, Space, Spin } from 'antd';
import { Button, Form, getRealUrl, message, Modal, Select, Upload } from '@maxtropy/components';
import { DefaultOptionType } from 'antd/es/cascader';
import { useState } from 'react';
import { apiV2DeviceLedgerImportPost } from '@maxtropy/device-customer-apis-v2';
import { DownloadOutlined } from '@ant-design/icons';
import { LogType } from '@/components/ImportLog/Prop';
import { useAssetTemplateOptions } from '@/pages/EquipmentLedger/service';
import { isNil } from 'lodash-es';

interface Props {
  visible: boolean;
  setVisible: (v: boolean) => void;
  updateFn: Function;
  cascaderData: any[];
}

const downloadUrl = '/api/v2/device-ledger/template/download';

const BatchConfigAssetInfo: React.FC<Props> = ({ visible, setVisible, updateFn, cascaderData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const typeIds = Form.useWatch('typeIds', form);
  const assetTemplateId = Form.useWatch('assetTemplateId', form);
  const { options: assetTemplateOptions, setTypeId: refreshTemplateOptions } = useAssetTemplateOptions();
  const isSelectedDeviceType = !isNil(typeIds) && typeIds.length > 0;
  console.log('cascaderData', cascaderData);
  console.log('assetTemplateOptions', assetTemplateOptions);

  const filter = (inputValue: string, path: DefaultOptionType[]) =>
    path.some(option => (option.label as string).toLowerCase().indexOf(inputValue.toLowerCase()) > -1);

  const cancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const submit = () => {
    if (loading) return;
    const fileKey = form.getFieldValue('fileKey');
    console.log('fileKey', fileKey);
    setLoading(true);
    apiV2DeviceLedgerImportPost({ fileKey, type: LogType.ASSET_TEMPLATE, typeId: typeIds?.at(-1), assetTemplateId })
      .then(resp => {
        if (resp?.fileKey) {
          Modal.error({
            title: '导入失败',
            content: (
              <>
                <span> 请现在下载错误信息,修改后重新导入。</span>
                <Button
                  type="link"
                  icon={<DownloadOutlined onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />}
                  style={{ paddingLeft: 0 }}
                  href={getRealUrl(resp.fileKey, true)}
                >
                  下载错误信息
                </Button>
              </>
            ),
            okText: '确定',
          });
          return;
        }
        message.success('导入成功');
        updateFn?.();
        cancel();
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      title="批量配置资产信息"
      open={visible}
      destroyOnClose
      contentStyle={{ padding: '20px 54px' }}
      footer={() => (
        <Space size={20}>
          <Button onClick={cancel} disabled={loading}>
            取消
          </Button>
          <Button type="primary" onClick={() => form.submit()} disabled={loading}>
            确认上传
          </Button>
        </Space>
      )}
      onCancel={cancel}
    >
      <Spin spinning={loading} size="large">
        <Form form={form} initialValues={{}} labelCol={{ span: 6 }} wrapperCol={{ span: 18 }} onFinish={submit}>
          <Form.Item label="设备类型" name="typeIds" rules={[{ required: true, message: '请选择设备类型' }]}>
            <Cascader
              options={cascaderData}
              maxTagCount="responsive"
              showCheckedStrategy="SHOW_CHILD"
              showSearch={{ filter }}
              placeholder={'请选择所属类目'}
              onChange={v => {
                form.setFieldValue('assetTemplateId', undefined);
                v?.length > 0 && refreshTemplateOptions(v?.at(-1) as number);
              }}
            />
          </Form.Item>
          <Form.Item
            label="资产信息模版"
            name="assetTemplateId"
            rules={[{ required: true, message: '请选择资产信息模版' }]}
          >
            <Select
              options={isSelectedDeviceType ? assetTemplateOptions : []}
              allowClear
              showSearch
              optionFilterProp="label"
              placeholder="请选择资产信息模版"
            />
          </Form.Item>
          {isSelectedDeviceType && assetTemplateId && (
            <Row style={{ marginBottom: 24 }}>
              <Col span={6} />
              <Col span={18}>
                <Button
                  type="link"
                  style={{ paddingLeft: 0 }}
                  href={`${downloadUrl}?typeId=${typeIds?.at(-1)}&assetTemplateId=${assetTemplateId}`}
                >
                  下载导入模版
                </Button>
              </Col>
            </Row>
          )}
          <Form.Item label="选择文件" rules={[{ required: true, message: '请先上传文件' }]} name="fileKey">
            <Upload
              listType="text"
              accept={['.xlsx', '.xls']}
              uploadText="点击上传"
              fileSize={20}
              tip="限制格式为xls或.xlsx, 不超过 20MB"
            />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default BatchConfigAssetInfo;
